import { gql } from 'react-apollo';

export default gql`
  mutation offerVdrRequest($offerId: ID!) {
    offerVdrRequest(offerId: $offerId)
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/offerVdrRequest.js